import { useOutletContext } from 'react-router-dom'
import { Organization } from '../../../models/organizations.models'
import PageOrderList from '../../../components/page/OrderList.page'

const OrganizationBoughtOrdersTab = () => {
  const { organization, useImperials } = useOutletContext<{
    organization: Organization
    useImperials: boolean
  }>()
  return (
    <PageOrderList useImperials={useImperials} withTabs clientOrganization={organization._id} />
  )
}
export default OrganizationBoughtOrdersTab
